import { useState } from "react";
import SweetAlert2 from "react-sweetalert2";
import axios from "axios";
import Card from "components/card";
import { Button } from "@chakra-ui/react";

const AdminUtils = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [swalProps, setSwalProps] = useState<any>({});

  // db_encrypt_helper state
  const [isEncrypt, setIsEncrypt] = useState<boolean>(false);
  const [inputData, setInputData] = useState<string>("");
  const [result, setResult] = useState<any>(null);

  const handleClear = () => {
    setInputData("");
    setResult(null);
  };

  const handleDbEncryptHelper = async () => {
    if (!inputData.trim()) {
      setSwalProps({
        show: true,
        title: "Error",
        text: "Please enter input data",
        icon: "error",
      });
      return;
    }

    setIsLoading(true);
    setResult(null);

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/api/superadmin/admin/action/utils",
        {
          func_name: "db_encrypt_helper",
          data: {
            is_encrypt: isEncrypt,
            input_data: inputData,
          },
        }
      );

      if (response.data) {
        setResult(response.data.payload);
      }
    } catch (error: any) {
      console.error("Error calling db_encrypt_helper:", error);
      setSwalProps({
        show: true,
        title: "Error",
        text: error.response?.data?.message || "Something went wrong",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="mt-3 text-sm">
        <Card extra="p-6">
          <div className="mb-6">
            <div className="mb-4">
              <label className="mb-2 block text-sm font-medium text-navy-700">
                Mode
              </label>
              <div className="flex gap-4 text-sm">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="encryptMode"
                    checked={!isEncrypt}
                    onChange={() => setIsEncrypt(false)}
                    className="mr-2"
                  />
                  Decrypt
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="encryptMode"
                    checked={isEncrypt}
                    onChange={() => setIsEncrypt(true)}
                    className="mr-2"
                  />
                  Encrypt
                </label>
              </div>
            </div>

            <div className="mb-4">
              <label className="mb-2 block text-sm font-medium text-navy-700">
                Input Data
              </label>
              <textarea
                value={inputData}
                onChange={(e) => setInputData(e.target.value)}
                placeholder="Enter data to encrypt/decrypt..."
                className="max-h-48 min-h-48 w-full overflow-auto rounded-lg border border-gray-300 p-3 text-sm focus:border-brand-500 focus:outline-none"
              />
              <div className="mt-3 flex gap-2">
                <Button
                  onClick={handleDbEncryptHelper}
                  isLoading={isLoading}
                  loadingText="Processing..."
                  className="btn-primary rounded-md px-4 py-2 text-sm font-medium text-white shadow-sm"
                >
                  Process
                </Button>
                <Button
                  onClick={handleClear}
                  variant="outline"
                  className="rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-navy-700 shadow-sm hover:bg-gray-50"
                >
                  Clear
                </Button>
              </div>
            </div>

            {result && (
              <div className="mt-4">
                <label className="mb-2 block text-sm font-medium text-navy-700">
                  Result
                </label>
                <pre className="max-h-64 overflow-auto rounded-lg bg-gray-100 p-4 text-sm">
                  {JSON.stringify(result, null, 2)}
                </pre>
              </div>
            )}
          </div>
        </Card>
      </div>

      <SweetAlert2
        {...swalProps}
        onConfirm={() => setSwalProps({ show: false })}
        customClass={{
          actions: "custom-swal2-popup-action",
          title: "custom-swal2-popup-title",
          confirmButton:
            "custom-swal2-popup-action custom-swal2-popup-action-confirm",
          cancelButton:
            "custom-swal2-popup-action custom-swal2-popup-action-cancel",
        }}
      />
    </>
  );
};

export default AdminUtils;
